import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import type { TourLevel } from '../types/tour.types';

interface TourState {
  isActive: boolean;
  currentTourId: string | null;
  currentStepIndex: number;
  selectedLevel: TourLevel;
  completedTours: string[];

  startTour: (tourId: string) => void;
  nextStep: () => void;
  prevStep: () => void;
  endTour: () => void;
  setLevel: (level: TourLevel) => void;
  markCompleted: (tourId: string) => void;
  isTourCompleted: (tourId: string) => boolean;
  resetCompleted: () => void;
}

export const useTourStore = create<TourState>()(
  devtools(
    persist(
      (set, get) => ({
        isActive: false,
        currentTourId: null,
        currentStepIndex: 0,
        selectedLevel: 'basico',
        completedTours: [],

        startTour: (tourId) =>
          set({
            isActive: true,
            currentTourId: tourId,
            currentStepIndex: 0,
          }),

        nextStep: () =>
          set((state) => ({
            currentStepIndex: state.currentStepIndex + 1,
          })),

        prevStep: () =>
          set((state) => ({
            currentStepIndex: Math.max(0, state.currentStepIndex - 1),
          })),

        endTour: () =>
          set({
            isActive: false,
            currentTourId: null,
            currentStepIndex: 0,
          }),

        setLevel: (level) => set({ selectedLevel: level }),

        markCompleted: (tourId) =>
          set((state) => ({
            completedTours: state.completedTours.includes(tourId)
              ? state.completedTours
              : [...state.completedTours, tourId],
            isActive: false,
            currentTourId: null,
            currentStepIndex: 0,
          })),

        isTourCompleted: (tourId) => get().completedTours.includes(tourId),

        resetCompleted: () => set({ completedTours: [] }),
      }),
      {
        name: 'tour-storage',
        partialize: (state) => ({
          completedTours: state.completedTours,
          selectedLevel: state.selectedLevel,
        }),
      }
    ),
    { name: 'TourStore' }
  )
);
